// eslint-disable-next-line import/prefer-default-export
export function validateEmail(email: string) : boolean {
  // https://www.w3resource.com/javascript/form/email-validation.php
  // eslint-disable-next-line no-useless-escape
  const emailFormat = /^\w+([.-]\w+)*@\w+([.-]\w+)*\.\w{2,63}$/;

  if (email && !email.match(emailFormat)) {
    return false;
  }

  return true;
}
